'use client';

import React from 'react';
import styles from './styles/WhatsIncluded.module.css';

export default function WhatsIncluded({ teacher, user, data, onEditWhatsIncluded }) {
  return (
    <section className={styles.whatsIncluded}>
      <h2 className={styles.title}>What’s Included</h2>

      <div className={styles.highlightsGrid}>
        <div className={styles.card}>
          <img className={styles.icon} src="/images/film-camera-icon.svg" alt="Live Meetings" />
          <h3 className={styles.itemTitle}>{data.title1 || ''}</h3>
          <p className={styles.itemDesc}>{data.content1 || ''}</p>
        </div>
        
        <div className={styles.card}>
          <img className={styles.icon} src="/images/icon-homework.svg" alt="Homework" />
          <h3 className={styles.itemTitle}>{data.title2 || ''}</h3>
          <p className={styles.itemDesc}>{data.content2 || ''}</p>
        </div>

        <div className={styles.card}>
          <img className={styles.icon} src="/images/icon-assessment.svg" alt="Assessment" />
          <h3 className={styles.itemTitle}>{data.title3 || ''}</h3>
          <p className={styles.itemDesc}>{data.content3 || ''}</p>
        </div>

        <div className={styles.card}>
          <img className={styles.icon} src="/images/icon-certificate.svg" alt="Certificate of Completion" />
          <h3 className={styles.itemTitle}>{data.title4 || ''}</h3>
          <p className={styles.itemDesc}>{data.content4 || ''}</p>
        </div>
      </div>

      <div className={styles.editSection}>
        {user?.role === 'ADMIN' ||
        user?.role === 'SUPER_ADMIN' ||
        (user?.role === 'TEACHER' && teacher?.id === user.id) ? (
          <button className={`${styles.btn} ${styles.editBtn}`} onClick={onEditWhatsIncluded}>
            Edit "What's Included" Section
          </button>
        ) : null}
      </div>
    </section>
  );
}